import React, { lazy } from 'react';
import { CheckSquare, Zap, Dumbbell, Flame, DollarSign, Wrench, Palette, Trees } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
import { PromoBanner } from './PromoBanner';
const bonuses = [{
  num: '#1',
  title: 'Checklist CERO ERROR Antes de Cortar',
  value: 9.99,
  description: <>
        Tu seguro anti-desastres: revisá{' '}
        <span className="text-white font-bold" data-id="element-42">
          TODO antes de hacer el primer corte.
        </span>{' '}
        Evitá errores costosos y material desperdiciado.
      </>,
  icon: CheckSquare,
  image: 'https://cdn.magicpatterns.com/uploads/5eDhPP2EZ3WvQfpGAdVVNM/ChatGPT_Image_20_ene_2026,_09_03_43_p.m._(1).png'
}, {
  num: '#2',
  title: 'Acelerador de Resultados — Ruta Express 7 Días',
  value: 14.99,
  description: <>
        Cronograma día por día para montar tu taller profesional en{' '}
        <span className="text-white font-bold" data-id="element-43">UNA semana</span> y tener tu
        primera pieza terminada.
      </>,
  icon: Zap,
  image: 'https://cdn.magicpatterns.com/uploads/jDM2eo8dpsXRoS6FdHdKs7/Bonus_2.png'
}, {
  num: '#3',
  title: 'Planos de Alto Valor — Trailers y Gym',
  value: 19.99,
  description: <>
        Planos exclusivos para fabricar equipamiento fitness que se vende a{' '}
        <span className="text-white font-bold" data-id="element-44">precios PREMIUM.</span> Tu atajo
        al mercado de alto valor.
      </>,
  icon: Dumbbell,
  image: 'https://cdn.magicpatterns.com/uploads/vtcrZh4VwQTU2ikksSDNPP/Bonus_3.png'
}, {
  num: '#4',
  title: 'Aprende a Soldar Desde Cero',
  value: 14.99,
  description: <>
        Guía técnica completa: tipos de soldadura, configuraciones, posiciones y
        errores comunes.{' '}
        <span className="text-white font-bold italic" data-id="element-45">
          Sin experiencia previa necesaria.
        </span>
      </>,
  icon: Flame,
  image: 'https://cdn.magicpatterns.com/uploads/r8gdQtuYWki9auxQ8d6Tw8/Bonus_4.png'
}, {
  num: '#5',
  title: 'Presupuesto y Ventas — Cierre Garantizado',
  value: 19.99,
  description: <>
        Cómo cotizar trabajos con seguridad y{' '}
        <span className="text-white font-bold" data-id="element-46">
          cerrar clientes sin regalar tu trabajo.
        </span>{' '}
        Fórmulas de precios y scripts de venta.
      </>,
  icon: DollarSign,
  image: 'https://cdn.magicpatterns.com/uploads/vGjQZfHd7B5mHSCi4WKg7V/Bonus_5.png'
}, {
  num: '#6',
  title: 'Herrería Desde Cero — Fundamentos Completos',
  value: 12.99,
  description: <>
        ¿Nunca tocaste una soldadora? Esta guía te lleva de la mano desde lo más
        básico hasta tu primer proyecto{' '}
        <span className="text-white font-bold" data-id="element-47">sin miedo.</span>
      </>,
  icon: Wrench,
  image: 'https://cdn.magicpatterns.com/uploads/2uuAgMWurr5cse6HiLrbwp/Bonus_6.png'
}, {
  num: '#7',
  title: 'Herrería Artística — Diseño Superior',
  value: 14.99,
  description: <>
        Proyectos con enfoque estético de alta gama. Creá piezas que son{' '}
        <span className="text-white font-bold" data-id="element-48">verdaderas obras de arte</span>{' '}
        en metal y diferenciáte.
      </>,
  icon: Palette,
  image: 'https://cdn.magicpatterns.com/uploads/stLdRMdJasiM3eFBEvhRT5/Bonus_7.png'
}, {
  num: '#8',
  title: 'Carpintería Que Vende — +100 Planos de Madera',
  value: 19.99,
  description: <>
        +100 planos de madera para combinar con hierro. Dominá ambos materiales
        y{' '}
        <span className="text-white font-bold" data-id="element-49">
          duplicá tu catálogo de productos.
        </span>
      </>,
  icon: Trees,
  image: 'https://cdn.magicpatterns.com/uploads/uyBzTrKU2aq3gKxiJac97k/Bonus_8.png'
}];
export function BonusSection() {
  return <section className="py-6 px-3 bg-[#111]" data-id="element-50">
      <PromoBanner data-id="element-51" />

      <div className="max-w-5xl mx-auto border-2 border-[#FFD700] rounded-xl p-3 md:p-6 relative bg-[#0d0d0d] shadow-[0_0_40px_rgba(255,215,0,0.1)]" data-id="element-52">
        <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-[#FFD700] text-black px-6 py-2 rounded-full font-black uppercase tracking-wider shadow-[0_0_20px_rgba(255,215,0,0.4)] text-sm whitespace-nowrap border-4 border-[#0d0d0d]" data-id="element-53">
          🎁 8 Bonos Exclusivos Si Ordenás Hoy
        </div>

        <div className="mt-5 grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-54">
          {bonuses.map((bonus, index) => <div key={index} className="bg-[#1a1a1a] rounded-xl overflow-hidden shadow-md" style={{
          borderLeft: '3px solid #FFD700',
          contain: 'layout style'
        }} data-id="element-55">
              {/* Image container with reserved aspect ratio to prevent CLS */}
              {bonus.image && <div className="p-3 pb-0" data-id="element-56">
                  <div className="relative w-full" style={{
              aspectRatio: '3 / 2'
            }} data-id="element-57">
                    <img src={bonus.image} alt={bonus.title} className="w-full h-full object-contain" style={{
                borderRadius: '20px',
                boxShadow: '0 0 18px rgba(255, 120, 0, 0.2), 0 0 6px rgba(255, 107, 0, 0.1)'
              }} loading={index < 2 ? 'eager' : 'lazy'} decoding={index < 2 ? 'sync' : 'async'} width={600} height={400} data-id="element-58" />
                  </div>
                </div>}

              {/* Content: Badge + Title → Description → Value tag */}
              <div className="p-3 flex gap-3 items-start" data-id="element-59">
                <div className="bg-[#FFD700] text-black font-bold text-sm w-8 h-8 rounded flex items-center justify-center flex-shrink-0 shadow-md" data-id="element-60">
                  {bonus.num}
                </div>
                <div className="flex-1" data-id="element-61">
                  <h3 className="text-lg font-bold text-white mb-1 leading-tight" data-id="element-62">
                    {bonus.title}
                  </h3>
                  <p className="text-gray-400 text-sm mb-2 leading-relaxed" data-id="element-63">
                    {bonus.description}
                  </p>
                  <div className="text-sm bg-[#0d0d0d] inline-block px-2 py-1 rounded border border-[#333]" data-id="element-64">
                    <span className="text-[#EF4444] line-through font-bold" data-id="element-65">
                      Valor{' '}
                      <PriceDisplay amount={bonus.value} className="inline" data-id="element-66" />
                    </span>
                    <span className="ml-2 text-[#22C55E] font-black uppercase" data-id="element-67">
                      — ¡GRATIS!
                    </span>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}